import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: -THEME.spacing.sm,
	},
	triggerRow: {
		background: THEME.colors.background.light,
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flexWrap: 'wrap' as const,
		padding: THEME.spacing.md,
		borderRadius: THEME.common.borderRadius,
		border: THEME.common.border,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
	},
	selectWrapper: {},
	// The source/answer Comboboxes flex-fill their column on row 2 of the
	// stacked trigger layout. `width: 100%` lets them grow to take all available
	// space; long labels still truncate (the input ellipsises overflow text)
	// because the flex parent bounds the width (`flex: 1; min-width: 0`).
	sourceComboboxInput: {
		width: '100%',
	},
	// Stacked trigger layout: checkbox/label on row 1, the dropdowns on row 2.
	triggerStack: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		width: '100%',
	},
	labelRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	inputRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
	},
	// A flex child that grows AND can shrink below its content width, so the
	// Combobox inside ellipsises instead of forcing the row wider / wrapping.
	fill: {
		flex: 1,
		minWidth: 0,
	},
	answerColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		// Cap the answers column at 40% so the source-question combobox (fill,
		// flex: 1) keeps the larger ~60% share — matches the question-level
		// QuestionVisibilityControls so the question picker is never the smaller one.
		flex: '0 1 40%',
		minWidth: 0,
	},
	answerRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flex: 1,
		minWidth: 0,
	},
	orRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	orLabel: {
		color: THEME.colors.text.light,
		fontStyle: 'italic',
		position: 'absolute',
		transform: `translateX(calc(-100% - ${THEME.spacing.sm}px))`,
	},
	// Truncates long option labels inside a Combobox item (paired with bs.truncateText).
	comboboxItemLabel: {
		flex: 1,
		minWidth: 0,
	},
	addAnswerButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: THEME.colors.primary.main,
		padding: 0,
		fontSize: THEME.typography.fontSizes.sm,
		textAlign: 'left' as const,
	},
	answerRemoveButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 0,
		lineHeight: 1,
		display: 'inline-flex',
		alignItems: 'center',
		color: THEME.colors.text.light,
	},
	isLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		whiteSpace: 'nowrap' as const,
		paddingTop: THEME.spacing.sm,
		flexShrink: 0,
	},
	removeButton: {
		flexShrink: 0,
		...CssSelectors.allChildren(
			{
				cursor: 'pointer',
				fontSize: 0,
				border: 0,
				padding: 0,
			},
			'button'
		),
	},
	addButton: {
		width: '100%',
		marginTop: THEME.spacing.sm,
	},
	addButtonInner: {
		width: '100%',
		borderStyle: 'dashed' as const,
	},
});
